"use client";

import React, {useState} from "react";
import {ScrollArea} from "@/components/ui/scroll-area";
import LocationCard from "@/components/dove-siamo/SedeCard";
import dynamic from "next/dynamic";

export interface Location {
    _id: string;
    title: string;
    address: string;
    email: string;
    phone: string;
    hours: string;
    imgUrl: string;
    longitude: number;
    latitude: number;
    slug: string;
    linkMaps: string;
}

interface DoveSiamoProps {
    locations: Location[];
}


const Mapbox = dynamic(() => import("@/components/Map/Mapbox"), {
    ssr: false,
    loading: () => <div className="w-full h-[400px] bg-gray-200 rounded-md animate-pulse"/>,
});

export default function DoveSiamo({locations}: DoveSiamoProps) {

    const [selectedLocationId, setSelectedLocationId] = useState<string | null>(null);

    const handleLocationSelect = (id: string) => {
        setSelectedLocationId(id);
    };

    console.log(locations);


    return (
        <>
            <div className="relative mt-[-100px]">
                <div className="bg-radial-checkout sm:bg-radial-right">
                </div>


                <div className="relative z-10">
                    <div className="pt-[100px] max-sm:px-4"></div>
                    <div
                        className="max-md:flex max-md:flex-col-reverse max-md:px-4 max-w-7xl mx-auto mt-12 pb-[100px] grid grid-cols-5 gap-8">
                        <div className="col-span-3  md:bg-white/80 rounded-lg md:px-6 md:py-4">
                            <div className="flex justify-between items-center gpa-x-8">
                                <div className="flex flex-col w-full">
                                    <h1 className="text-4xl font-semibold w-full">Le nostre sedi</h1>
                                    <p className="text-sm md:text-lg lg:text-xl w-full">{locations?.length} sedi in
                                        tutta Italia</p>
                                </div>
                            </div>

                            <div className="space-y-4 py-4">
                                <ScrollArea className="md:h-[65vh] custom-scrollbar">
                                    {locations.map((location) => (
                                        <LocationCard
                                            key={location._id}
                                            id={location._id}
                                            title={location.title}
                                            address={location.address}
                                            email={location.email}
                                            phone={location.phone}
                                            hours={location.hours}
                                            imgUrl={location.imgUrl}
                                            linkMaps={location.linkMaps}
                                            slug={location.slug}
                                            onSelect={handleLocationSelect}
                                        />
                                    ))}
                                </ScrollArea>
                            </div>
                        </div>

                        <div className="col-span-2 md:bg-white/80 rounded-lg md:p-2 max-md:h-[200px]">
                            <Mapbox
                                selectedLocationId={selectedLocationId}
                                locations={locations.map(location => ({
                                    id: location._id,
                                    title: location.title,
                                    longitude: location.longitude,
                                    latitude: location.latitude,
                                    imgUrl: location.imgUrl
                                }))}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
